import { createAPI } from "../apisServer";

const apiServer = createAPI("aiServer");

const reqStatusAi = {
	status: async function () {
		return apiServer
			.get("ai-server/ping")
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqStatusAi;
